export const CARD_TITLE_COLORS = {
  orange: 'var(--orange-500)',
  green: 'var(--green-500)',
  blue: 'var(--blue-900)',
  purple: 'var(--purple-500)',
  yellow: 'hsla(45, 78%, 20%, 1)',
} as const;
